// 
export const LOAD_LIST = 'LOAD_LIST';
export const LOAD_PAGINATION = 'LOAD_PAGINATION';
export const LOAD_NEW_LIST = 'LOAD_NEW_LIST';
